import store, { RootState } from '@/redux/store'
import { USER_RIGHTS } from '@/modules/base/util/constants'

// the same wait as the redirect on "/" (allRoutes) - then the welcome screen shows up anyway
export const TRIAL_SUBSCRIPTION_TIMEOUT = 15000

const isReady = (state: RootState): boolean => Boolean(
  state.subscription?.details?.subscriptions?.length
  && state.user?.info?.userRights?.includes(USER_RIGHTS.INVOICES.READ),
)

/**
 * Resolves once the tenant has a subscription and the user may open invoices. The trial of a new
 * orgaMAX tenant is only created after the registration (startInitialTrial), which then navigates
 * to "/firstSteps" - a page opened before would be left again.
 */
const waitForTrialSubscription = (timeout = TRIAL_SUBSCRIPTION_TIMEOUT): Promise<void> => new Promise(resolve => {
  if (isReady(store.getState())) {
    resolve()
    return
  }

  let unsubscribe = () => {}
  const timer = setTimeout(() => {
    unsubscribe()
    resolve()
  }, timeout)
  unsubscribe = store.subscribe(() => {
    if (!isReady(store.getState())) return
    clearTimeout(timer)
    unsubscribe()
    resolve()
  })
})

export default waitForTrialSubscription
